import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export default function Footer() {
  const { user } = useSelector((state) => ({ ...state }));
  return (
    <div className="footer">
      <div className="buttonsFooter">
        <div>
          {user && user.token ? (
            <>
              <Link to="/create" className="create">
                Create a new event
              </Link>
              <Link to="/user/password" className="create">
                Reset Password
              </Link>
              <Link to="/user/events" className="create">
                My events
              </Link>
            </>
          ) : (
            <>
              <Link to="/" className="create">
                Home
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
